module.exports = __webpack_public_path__ + "images/icon/mail_inspector_unset-764bc3f0.svg";